import styled from '@emotion/styled';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { ReactNode } from 'react';
import { useTransAppProductName } from 'hooks/useTrans';
import tfsoftwareWhatsappImage from 'assets/channels/tfsoftware/whatsapp.png';
import tfsoftwareWechatImage from 'assets/channels/tfsoftware/wechat.png';
import { useTranslate } from '@tolgee/react';

const Contact = styled.div`
  width: 145px;
  text-align: center;
  > img {
    width: 116px;
    height: auto;
  }
  p {
    margin-top: 5px;
    font-size: 12px;
    text-align: center;
    white-space: pre-line;
  }
`;

export function ChatServiceQrImg(props: { qrCode?: string; text?: ReactNode }) {
  const { contactQrcode } = useFlagConfigValue();

  const t = useTransAppProductName();

  const { qrCode = contactQrcode, text = t('authShop.微信扫一扫，添加客户服务专家') } = props;

  return (
    <Contact>
      <img src={qrCode} alt="qrcode" />
      <p>{text}</p>
    </Contact>
  );
}

export function ChatServiceQrImgWhatsapp() {
  const { contactQrcode, contactNumber } = useFlagConfigValue();

  const t = useTransAppProductName();

  return (
    <Contact>
      <img src={contactQrcode} alt="qrcode" />
      <p>{t('app_header_contact_qrcode_whatsapp', { number: contactNumber })}</p>
    </Contact>
  );
}

export function ChatServiceQrImgTfsoftware() {
  const { t } = useTranslate();

  return (
    <Container>
      <Contact>
        <img src={tfsoftwareWhatsappImage} alt="whatapp" />
        <p>
          WhatsApp
          <br />
          {t('remind.扫码联系我们')}
        </p>
      </Contact>
      <Contact>
        <img src={tfsoftwareWechatImage} alt="wechat" />
        <p>
          {t('translation.微信')}
          <br />
          {t('remind.扫码联系我们')}
        </p>
      </Contact>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
